/**
 * セット企画検索画面　出力VOクラス
 */
export class KYMW1313OutputModel {
  /** 処理区分(1：検索、2：選択) */
  public accessDiv: string = <string>'0';
  /** プロモーション区分(B：バンドル、P：ミックスマッチ、T：わくわくポイント、S：セット企画) */
  public promotionDiv: string = null;
  /** プロモーション名称 */
  public promotionName: string = null;
  /** Ｐコード */
  public pCode: string = null;
  /** セット企画商品名 */
  public setDelivGoodsName: string = null;
  /** 生協コード */
  public coopCode: string = null;
  /** 部門コード */
  public classCode: string = null;
  /** プロモーションＮＯ */
  public promotionNo: string = null;
}
